import styled, { css } from 'styled-components';
import { COMPACT_WINDOW_MEDIA } from '../../constants';

const heroBackgroundByVariant = {
  info: 'porterBlue50',
  success: 'porterLime200',
  danger: 'porterRed50',
};

export const HeroCard = styled.section`
  background-color: ${({ theme, $variant }) =>
    theme.colors[
      heroBackgroundByVariant[$variant] || heroBackgroundByVariant.info
    ]};
  border-radius: 16px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;

  ${({ $compact }) =>
    $compact &&
    css`
      @media ${COMPACT_WINDOW_MEDIA} {
        display: grid;
        grid-template-columns: 40px 1fr;
        align-items: start;
        column-gap: 16px;
        row-gap: 4px;
        padding: 16px;
        text-align: left;
      }
    `}
`;

export const HeroIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, $variant }) =>
    $variant === 'danger'
      ? theme.colors.porterRed500
      : theme.colors.porterBlue500};
  color: ${({ theme }) => theme.colors.semantic.text.inverse};
  font-size: 24px;
  line-height: 1;

  svg {
    width: 24px;
    height: 24px;
  }

  ${({ $compact }) =>
    $compact &&
    css`
      @media ${COMPACT_WINDOW_MEDIA} {
        grid-row: span 2;
        width: 40px;
        height: 40px;
      }
    `}
`;

export const HeroTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.semantic.text.primary};
`;

export const HeroText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.semantic.text.secondary};

  strong {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.semantic.text.primary};
  }
`;
